const translations = {
  'fields.name': 'Nombre',
  'fields.createdAt': 'Fecha de Creación',
  'fields.updatedAt': 'Última Actualización',
  'fields.branch': 'Sucursal',
  'fields.headquarter': 'Matriz',
  'fields.status': 'Estado',
  'fields.checklist': 'Cuestionario',
  'fields.user': 'Usuario',
  'fields.scheduling': 'Fecha de Agendamiento',
  'fields.endDate': 'Fecha de Finalización',
  'fields.notes': 'Observaciones',
  'fields.checkIn': 'Check In',
  'fields.checkOut': 'Check Out',
  'fields.headquarterBranch': 'Cliente',
  'fields.assets': 'Activos',
  'fields.activityScore': 'Puntuación de actividad',
  'fields.negatives': 'Respuestas no',
  'fields.actionPlans': 'Planes de acción',
  'fields.serviceTime': 'Tiempo de atención',
  'resume.filters.questionTypes': 'Tipo de pregunta',
  'resume.filters.answerTypes': 'Respuestas',
  'resume.filters.actionPlans': 'Planes de Acción',
  'resume.accordion.general': 'Resumen General',
  'resume.accordion.negatives': 'Respuestas No',
  'resume.accordion.actionPlans': 'Planes de Acción',
  'resume.accordion.pendencies': 'Pendencias',
  'execution.accordion.general': 'Detalles',
  activities: 'Actividades',
  listing: 'Listado',
  actionPlans: 'Planes de Acción',
  'resume.pdf.betaAlertTitle': 'La nueva generación de PDF aún está en desarrollo',
  'resume.pdf.betaAlertMessage': 'Te redirigiremos a la versión antigua para generar tu impresión, ¿puede ser?',
  'pdf.options.printSettingsTitle': 'Configuraciones de impresión',
  'pdf.options.showQuestionInfo': 'Mostrar información de las preguntas',
  'pdf.options.hideConfidentialInfo': 'Ocultar campos adicionales confidenciales',
  'pdf.options.hidePrivateQuestion': 'Ocultar preguntas confidenciales',
  'pdf.options.hideChildrenServiceOrders': 'Ocultar actividades hijas',
  'pdf.options.childrenFieldsTitle': 'Campos de las actividades hijas',
  'pdf.options.showField': 'Mostrar {{field}}',
  'pdf.options.headerImageTitle': 'Imagen de encabezado',
  'pdf.options.headerImageHeight': 'Altura de la imagen',
  'pdf.options.add': 'Agregar',
  'pdf.counters.score': 'Puntuación',
  'pdf.counters.nonCompliances': 'No conformidades',
  'pdf.counters.actionPlans': 'Planes de acción',
  'pdf.counters.time': 'Tiempo',
  'pdf.reason': 'Motivo',
  'pdf.createdAt': 'Creada el {{date}}',
  anonymousResponse: 'Respondido anónimamente',
  'show.userOrGroup': 'Usuario/Grupo',
  'show.placeOrPerson': 'Local/Persona',
  'show.asset': 'Activo',
  'show.checklist': 'Cuestionario',
  'show.scheduling': 'Agendamiento',
  'show.priority': 'Prioridad',
  'show.sla': 'SLA',
  'show.address': 'Dirección',
  'show.description': 'Descripción',
  'show.publicExecutionLink': 'Enlace público de ejecución',
  'show.publicResumeLink': 'Enlace público de resumen',
  'show.documents': 'Documentos',
  'show.history': 'Historial',
  'show.noDate': 'Sin fecha',
  'show.noPriority': 'Sin prioridad',
  'show.openedAt': 'Fecha de apertura',
  'tabs.details': 'Detalles',
  'tabs.timeline': 'Línea de tiempo',
  'tabs.triggerEvents': 'Eventos de disparador',
  'tabs.audit': 'Auditoría',
  'bulkEdit.title': 'Registro en masa',
  'clone.title': 'Clonando Actividad',
  'clone.message': 'Esta acción creará una nueva actividad con los mismos datos de la actividad {{yearlyId}}',
  'editStatus.title': 'Cambiando estado de actividad',
  'editStatus.title_plural': 'Cambiando estado de actividades',
  'export.title': 'Exportando actividad',
  'export.title_plural': 'Exportando actividades',
  'remove.button': 'Eliminar',
  'execution.title': 'Respondiendo actividad: {{title}}',
  'resume.title': 'Resumen: {{yearlyId}}',
  'resume.fullResume': 'Resumen completo',
  'statusReason.unproductiveReason': 'Motivo de improductividad',
  'statusReason.evidences': 'Evidencias',
  'statusReason.signature': 'Firma',
  'statusReason.name': 'Nombre',
  'statusReason.document': 'Documento',
  'indicators.nonCompliances': 'No conformidades',
  'execution.saveError': 'Error al guardar las respuestas',
  'execution.requiredAnswersMissing': 'Faltan respuestas obligatorias',
  'execution.requiredAnswersMissingMessage': 'Verifique las preguntas con las etiquetas rojas.',
  'execution.sendError': 'Ocurrió un error al enviar las respuestas',
  'execution.sendErrorMessage': 'Verifique las preguntas con las etiquetas rojas.',
  'execution.paused': 'Actividad pausada',
  'execution.completed': '¡Actividad completada!',
  'execution.saved': '¡Actividad guardada!',
  'resume.generateCustomDocument': 'Generar Documento Personalizado',
  'resume.generatePDF': 'Generar PDF',
  'export.validation.missingIds': 'Faltan ids',
  'export.validation.required': 'Campo obligatorio',
  'export.sendingRequest': 'Enviando solicitud...',
  'export.generatingFile': 'Generando archivo...',
  'export.error': '¡Ocurrió un error al exportar!',
  'bulkEdit.openingAsChild': 'Abriendo como actividad hija de:',
  'bulkEdit.makeParentPending': 'Transformar padre en pendiente',
  'bulkEdit.fields.code': 'Código',
  'bulkEdit.fields.name': 'Nombre',
  'bulkEdit.fields.checklist': 'Cuestionario',
  'bulkEdit.fields.placeType': 'Tipo de destino',
  'bulkEdit.fields.place': 'Destino',
  'bulkEdit.fields.asset': 'Activo',
  'bulkEdit.fields.responsible': 'Responsable',
  'bulkEdit.fields.address': 'Dirección',
  'bulkEdit.fields.scheduling': 'Agendamiento',
  'bulkEdit.fields.priority': 'Prioridad',
  'bulkEdit.fields.description': 'Descripción',
  'interpolations.activityCode': 'Código de actividad',
  'interpolations.activityName': 'Nombre de actividad',
  'interpolations.activityDescription': 'Descripción de actividad',
  'interpolations.checklistName': 'Nombre de cuestionario',
  'interpolations.status': 'Estado',
  'interpolations.projectName': 'Nombre del proyecto',
  'interpolations.placeName': 'Nombre del local',
  'interpolations.publicResumeLink': 'Enlace público de resumen',
  'interpolations.publicExecutionLink': 'Enlace público de ejecución',
  'interpolations.userName': 'Nombre del usuario',
  'interpolations.userEmail': 'Email del usuario',
  'interpolations.userGroup': 'Grupo del usuario',
  'interpolations.destinationName': 'Nombre de destino',
  'interpolations.fullDestinationName': 'Nombre completo de destino',
  'interpolations.schedulingDate': 'Fecha de agendamiento',
  'interpolations.openingDate': 'Fecha de apertura (inicio o creación)',
  'interpolations.completionDate': 'Fecha de conclusión',
  'interpolations.savedActivityUser': 'Usuario de actividad guardada',
  'interpolations.updatedActivityPlace': 'Local de actividad actualizada',
  'interpolations.updatedActivityAsset': 'Activo de actividad actualizada',
  'interpolations.savedActivityChecklist': 'Cuestionario de actividad guardada',
  'interpolations.updatedNonCompliancePlace': 'Local de no conformidad actualizada',
  'interpolations.updatedNonComplianceAsset': 'Activo de no conformidad actualizada',
  'interpolations.groups.activity': 'Actividad',
  'interpolations.groups.user': 'Usuario',
  'interpolations.groups.destination': 'Destino',
  'interpolations.groups.dates': 'Fechas'
}

export default translations
